import React, { useState } from 'react';

import FrontPage from './FrontPage';
import AddressForm from './AddressForm';
import ContactForm from './ContactForm';
import SuccessPage from './SuccessPage';

/**
 * Functional component that initializes the multi-step form
 *
 * useState hooks set the initial state of the component. State is controlled with the set hooks
 */
const Form = () => {
    const [address, setFormAddress] = useState('');
    const [step, setStep] = useState(0);
    const [headers, setHeaders] = useState({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const [commonErrorMsg, setCommonErrorMsg] = useState('');

    const props = {
        address,
        step,
        commonErrorMsg,
        headers,
        setFormAddress,
        setStep,
        setHeaders,
        setCommonErrorMsg,
    };

    switch (step) {
        case 0:
            return <FrontPage {...props} />;
        case 1:
            return <AddressForm {...props} />;
        case 2:
            return <ContactForm {...props} />;
        case 3:
            return <SuccessPage />;
        default:
            return <FrontPage {...props} />;
    }
};

export default Form;
